import { Link } from "react-router-dom";
import { STATS } from "@/mocks/content";

const HERO_IMG =
  "https://readdy.ai/api/search-image?query=dimly%20lit%20film%20studio%20at%20night%20seen%20from%20behind%20the%20camera%20rig%2C%20silhouettes%20of%20the%20director%20and%20crew%20around%20a%20glowing%20monitor%2C%20warm%20practical%20tungsten%20lights%20with%20volumetric%20haze%2C%20deep%20charcoal%20shadows%20contrasted%20by%20soft%20amber%20highlights%2C%20cinematic%20wide%20establishing%20shot%2C%20atmospheric%20editorial%20documentary%20photography%2C%20film%20grain&width=1920&height=1200&seq=home-hero-bts&orientation=landscape";

export default function Hero() {
  return (
    <section className="film-grain relative flex min-h-[92vh] w-full flex-col justify-end overflow-hidden pt-28 pb-0">
      <div className="absolute inset-0 -z-10">
        <img
          src={HERO_IMG}
          alt="电影片场深夜拍摄现场的幕后影像"
          className="h-full w-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-50/85 via-background-50/55 to-background-50" />
        <div className="absolute inset-0 bg-gradient-to-r from-background-50/70 via-transparent to-transparent" />
      </div>

      <div className="mx-auto w-full max-w-7xl px-4 pb-16 pt-16 md:px-6 md:pb-20">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 rounded-full border border-primary-400/40 bg-primary-500/10 px-3 py-1 text-xs font-medium tracking-widest text-primary-300">
            <i className="ri-film-line" /> 小电影 · 幕后档案
          </span>
          <h1 className="mt-6 font-heading text-4xl font-black leading-tight text-foreground-950 md:text-6xl">
            把正片之外，
            <br className="hidden md:block" />
            每一格都讲给你听
          </h1>
          <p className="mt-6 max-w-xl text-base leading-relaxed text-foreground-600 md:text-lg">
            拍摄花絮、幕后故事、导演访谈、片场日记与制作特辑——追完小电影正片还想挖幕后料？在幕外，用番外视角补全每一部短片的创作细节。
          </p>
          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <Link
              to="/column"
              className="inline-flex h-12 items-center justify-center whitespace-nowrap rounded-md bg-primary-500 px-6 text-sm font-semibold text-foreground-100 transition hover:bg-primary-400"
            >
              翻一翻幕后档案
              <i className="ri-arrow-right-line ml-2" />
            </Link>
            <Link
              to="/column?c=special"
              className="inline-flex h-12 items-center justify-center whitespace-nowrap rounded-md border border-background-300 bg-background-100/70 px-6 text-sm font-medium text-foreground-900 backdrop-blur transition hover:border-primary-400 hover:text-primary-200"
            >
              看制作特辑
            </Link>
          </div>
        </div>

        <dl className="mt-16 grid max-w-4xl grid-cols-2 gap-px overflow-hidden rounded-lg border border-background-200 bg-background-200 sm:grid-cols-4">
          {STATS.map((s) => (
            <div key={s.label} className="flex flex-col gap-1 bg-background-100/90 px-5 py-4">
              <dt className="font-display text-2xl font-bold text-primary-300 md:text-3xl">{s.value}</dt>
              <dd className="text-xs text-foreground-500">
                {s.label} <span className="ml-1 text-foreground-600">{s.en}</span>
              </dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}